import * as React from "react";
import GlobalStyles from "@mui/joy/GlobalStyles";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemButton, { listItemButtonClasses } from "@mui/joy/ListItemButton";
import ListItemContent from "@mui/joy/ListItemContent";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import ReceiptIcon from '@mui/icons-material/Receipt';

import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { checkUserRole, closeSidebar } from "../utils/utils";
import { Add, PendingActions, Report } from "@mui/icons-material";
import { replace, useLocation, useNavigate } from "react-router-dom";

import { useGetFetchUserManualMutation } from "../services/vendor/VendorApi";
import { useGetApiCheckPernerQuery, useGetUserRoleMutation } from "../services/auth/authApiSlice";
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import { SSO_BASE_URL } from "../utils/constants";
import { toast } from "react-toastify";
import UploadIcon from '@mui/icons-material/Upload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useGetEmployeeLogoutMutation } from "../services/invoices/InvoiceApiSlice";

export default function EmployeeSidebar() {
  const navigate = useNavigate();
  const location = useLocation();


  const [isAdmin, setIsAdmin] = React.useState(false);
  const [roleList, setRoleList] = React.useState([]);
  const [getUserManual] = useGetFetchUserManualMutation();
  const { data: checkedPerner } = useGetApiCheckPernerQuery(localStorage.getItem("employee_id"));
  const [getRoleData] = useGetUserRoleMutation();
  const [getSessionLogout] = useGetEmployeeLogoutMutation();


  React.useEffect(() => {
    if (checkedPerner?.success) {
      setIsAdmin(checkedPerner?.match);
    }
  }, [checkedPerner])


  const getrouteAuth = async () => {
    try {
      const response: any = await getRoleData("user_id=" + (localStorage.getItem("employee_id") ?? ""));
      if (response?.data?.length === 0) {

        navigate("/employee_landing_page", { replace: true });
      } else {
        if (response?.data.length > 0) {
          setRoleList([...response?.data]);
          localStorage.setItem('roleList', JSON.stringify(response?.data));

        }
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
      navigate("/login", { replace: true });
    }
  }

  React.useEffect(() => {
    if (localStorage.getItem('roleList')) {
      setRoleList([...JSON.parse(localStorage.getItem('roleList'))]);
    } else {

      getrouteAuth();
    }
  }, []);
  const openUserManual = async () => {

    try {
      const response = await getUserManual(5);
      if (response?.data?.success) {
        // const { data, file_name, mime_type, presigned_url } = response?.data?.file;
        const { presigned_url } = response?.data?.file;
        window.open(presigned_url, "_blank");

        // Clean up the URL after a short delay to allow the browser to load it
        setTimeout(() => {
          URL.revokeObjectURL(presigned_url);
        }, 1000);
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  const handleSSOLogout = async () => {

    try {
      await getSessionLogout({});
    } catch (err) { }

    window.history.pushState(null, window.location.pathname);
    let origin = window.location.origin
    // window.location.replace(`${SSO_BASE_URL}/logout`);
    window.location.replace(`${SSO_BASE_URL}/logout`);

    setTimeout(() => {
      localStorage.clear();
      // navigate("/login", { replace: true });
    }, 1000);
  };

  var activeUrl = location?.pathname;

  return (
    <Sheet
      style={{ background: "#e6eef3" }}
      className="Sidebar"
      sx={{
        position: { xs: "fixed", md: "sticky" },
        transform: {
          xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))",
          md: "none",
        },
        transition: "transform 0.4s, width 0.4s",
        zIndex: 1000,
        height: "92dvh",
        width: "var(--Sidebar-width)",
        top: 0,
        p: 2,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderRight: "1px solid",
        borderColor: "divider",
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--Sidebar-width": "220px",
            [theme.breakpoints.up("lg")]: {
              "--Sidebar-width": "240px",
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: "fixed",
          zIndex: 9998,
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          opacity: "var(--SideNavigation-slideIn)",
          backgroundColor: "var(--joy-palette-background-backdrop)",
          transition: "opacity 0.4s",
          transform: {
            xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))",
            lg: "translateX(-100%)",
          },
        }}
        onClick={() => closeSidebar()}
      />

      <Box
        sx={{
          minHeight: 0,
          overflow: "hidden auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <Typography level="body-xs">{localStorage.getItem("userRole") === "employee" ? "Employee" : "Vendor"}</Typography>
        <List
          size="sm"
          sx={{
            gap: 1,
            "--List-nestedInsetStart": "30px",
            "--ListItem-radius": (theme) => theme.vars.radius.sm,
          }}
        >
          <ListItem className={`${activeUrl?.includes("/employee_landing_page") ? "menuActive" : ''}`}>
            <ListItemButton onClick={() => navigate("/employee_landing_page")}>
              <HomeRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Dashboard</Typography>
              </ListItemContent>
              {/* <PlayArrowIcon /> */}
            </ListItemButton>
          </ListItem>

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'approver']) && <ListItem onClick={() => navigate("/pending-bills")} className={`${activeUrl?.includes("pending-bills") ? "menuActive" : ''}`}>
            <ListItemButton>
              <PendingActions />
              <ListItemContent>
                <Typography level="title-sm">Approval Pending</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>}

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'approver', 'create']) && <ListItem onClick={() => navigate("/employee-bills")} className={`${activeUrl?.includes("/employee-bills") ? "menuActive" : ''}`}>
            <ListItemButton>
              <ShoppingCartRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">My Request</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>}

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'create']) && <ListItem onClick={() => navigate("/employee/add-new-entry")} className={`${activeUrl?.includes("/employee/add-new-entry") ? "menuActive" : ''}`}>
            <ListItemButton>
              <Add />
              <ListItemContent>
                <Typography level="title-sm">Add New Entry</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>}

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'approver', 'create']) && (
            <ListItem onClick={() => navigate("/tds-file-upload")} className={`${activeUrl?.includes("/tds-file-upload") ? "menuActive" : ''}`}>
              <ListItemButton>
                <UploadIcon />
                <ListItemContent>
                  <Typography level="title-sm">Upload TDS</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}
          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'approver', 'create']) && (
            <ListItem onClick={() => navigate("/tds-file-download-e")} className={`${activeUrl?.includes("/tds-file-download-e") ? "menuActive" : ''}`}>
              <ListItemButton>
                <FileDownloadIcon />
                <ListItemContent>
                  <Typography level="title-sm">View/Download TDS</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin']) && <ListItem onClick={() => navigate("/reject-invoice")} className={`${activeUrl?.includes("/reject-invoice") ? "menuActive" : ''}`}>
            <ListItemButton>
              <SwipeLeftIcon />
              <ListItemContent>
                <Typography level="title-sm">Reject Invoice</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>}

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'approver']) && (
            <ListItem onClick={() => navigate("/reports")} className={`${activeUrl?.includes("/reports") ? "menuActive" : ''}`}>
              <ListItemButton>
                <EngineeringIcon />
                <ListItemContent>
                  <Typography level="title-sm">Overview Reports</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}
          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin', 'approver']) && (
            <ListItem onClick={() => navigate("/btsreports")} className={`${activeUrl?.includes("/btsreports") ? "menuActive" : ''}`}>
              <ListItemButton>
                <EngineeringIcon />
                <ListItemContent>
                  <Typography level="title-sm">Details Reports</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}

          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin']) && (
            <ListItem onClick={() => navigate("/gem-invoices")} className={`${activeUrl?.includes("/gem-invoices") ? "menuActive" : ''}`}>
              <ListItemButton>
                <ReceiptIcon />
                <ListItemContent>
                  <Typography level="title-sm">GEM Invoices</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}
          {roleList.length > 0 && checkUserRole(roleList, ['superadmin', 'admin']) && (
            <ListItem onClick={() => navigate("/action-logs")} className={`${activeUrl?.includes("/action-logs") ? "menuActive" : ''}`}>
              <ListItemButton>
                <ReceiptIcon />
                <ListItemContent>
                  <Typography level="title-sm">Action Taken</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}

          <ListItem onClick={openUserManual}>
            <ListItemButton>
              <Report />
              <ListItemContent>
                <Typography level="title-sm">User Manual</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
          <ListItem onClick={() => handleSSOLogout()}>
            <ListItemButton>
              <LogoutRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Logout</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      <Divider />
    </Sheet>
  );
}

